import styled from 'styled-components';

import { ImageStaticWrapper } from 'approot/shared/images/images.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';

export const DrawEditImage = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${ImageStaticWrapper} {
    ${flexCentreAlignCss}
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
